import React from "react";
import { Image } from "semantic-ui-react";

export default (props) => {
  return <Image {...props} />;
};
